module.exports = __webpack_public_path__ + "static/media/emc.2d34ea37.png";